<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>Hello world</h2>

</div>
